/* eslint-disable no-unused-vars */
import React from 'react';
import moment from 'moment';
import { toISOString } from 'pages/AppointmentsPage';
import { useGetThematicPackages } from '../hooks/thematic-packages-hooks';
import AppLoader from '../components/basic/AppLoader';

const getSlotsBetweenDays = (start, end, slotDuration) => {
  let minDate = moment(start);
  const maxDate = moment(end);

  const dates = [];

  while (minDate <= maxDate) {
    const newMinDate = moment(minDate).add(slotDuration, 'minutes');

    if (newMinDate > maxDate) {
      dates.push({ date_from: toISOString(minDate.toDate()), date_to: toISOString(maxDate.toDate()) });
    } else {
      dates.push({ date_from: toISOString(minDate.toDate()), date_to: toISOString(newMinDate.toDate()) });
    }

    minDate = minDate.add(slotDuration, 'minutes');
  }

  return dates;
};

const getWorkingDaysBetweenDays = (start, end, scheduleEnd) => {
  const days = [];

  for (let m = moment(start); m.isBefore(scheduleEnd); m.add(1, 'days')) {
    const dayOfWeek = m.isoWeekday();
    if (6 !== dayOfWeek && 7 !== dayOfWeek) {
      const minDate = moment(m);
      minDate.set({ hour: start.hour(), minute: start.minutes(), second: 0, millisecond: 0 });

      const maxDate = moment(m);
      maxDate.set({ hour: end.hour(), minute: end.minutes(), second: 59, millisecond: 59 });

      days.push({ date_from: toISOString(minDate.toDate()), date_to: toISOString(maxDate.toDate()) });
    }
  }

  return days;
};

const arr = {
  doctor: {
    non_pgx: {
      select_lang_desc: 'Select the language you want to complete the registration and view the results reports of your patients/clients',
    },
    pgx: {
      have_referral_part1: 'Enter your patient\'s referral number for the iDNA PGx CNS Pharmacogenetic Analysis in the field below.',
      select_lang_desc: 'Select the language you want to complete the registration and view your patients\' results reports.',
    },
  },
  child: {
    select_lang_desc: 'Select the language you want to complete the registration for your minor child and view the personal results report.',
  },
};

// strict object check
function isObject(value) {
  return '[object Object]' === toString.call(value);
}

// strict array check
function isArray(value) {
  return '[object Array]' === toString.call(value);
}

function propPicker(data = {}, value) {
  // type guard for data parameter
  // ensure it is an object
  if (!isObject(data)) {
    throw new TypeError('first parameter must be an object');
  }

  // the object or result to return
  let output = {};

  // iterate through data
  // to pick properties
  Object.keys(data).forEach((key) => {
    // add key (property) to the result to be
    // returned if it is present on the
    // data object
    if (('string' === typeof data[key] || data[key] instanceof String) && data?.[key].toLowerCase()?.includes(value.toLowerCase())) {
      output[key] = data[key];
    // eslint-disable-next-line brace-style
    }

    // recursive traverse the key (property)
    // if it is an object
    else if (isObject(data[key])) {
      const selectedProps = propPicker(data[key], value);
      let obj;

      // add keys (properties) from nested object
      // if the key is present on the data object
      if (Object.keys(selectedProps).length) {
        obj = {
          [key]: selectedProps,
        };
      }

      // merge main object and keys with
      // nested objects with filtered keys
      output = { ...output, ...obj };
    }
  });

  return output;
}

const Playground = () => {
  const objFilter = (value, objToFilter) => {

  };

  console.log(propPicker(arr, 'the language'));

  return (
    null
  );
};

export default Playground;
